// All site copy lives here so it can be edited without touching layout code.

export const NAV_LINKS = [
  { href: '#capabilities', label: 'Capabilities' },
  { href: '#stack', label: 'Stack' },
  { href: '#approach', label: 'Approach' },
  { href: '#contact', label: 'Contact' },
];

export const HERO = {
  title: (
    <>
      Software built for <em>flight</em>
    </>
  ),
  lead:
    'We design and engineer apps, tools and data systems for pilots, operators and aviation teams — from the wrist to the cockpit to the cloud.',
};

export const CAPABILITIES = [
  {
    id: 'efb',
    title: 'Pilot & EFB apps',
    body:
      'Briefings, weather, weight & balance, checklists and logbooks — designed for glare, gloves and turbulence, and built to keep working offline at altitude.',
  },
  {
    id: 'wearables',
    title: 'Wearables & companion apps',
    body:
      'Glanceable tools for the wrist — live weather, timers and nearest airports — built natively for the watches pilots already wear, and synced with their phones.',
  },
  {
    id: 'ops',
    title: 'Operations & dispatch',
    body:
      'Scheduling, dispatch, fleet status and crew tools that keep operators on time and everyone working from the same picture.',
  },
  {
    id: 'data',
    title: 'Aviation data & APIs',
    body:
      'Pipelines and APIs for METARs, TAFs, NOTAMs, ADS-B and navigation data — parsed, validated and served fast to every app you run.',
  },
];

export const DATA_FORMATS = [
  'METAR',
  'TAF',
  'NOTAM',
  'PIREP',
  'SIGMET',
  'AIRMET',
  'ADS-B',
  'GDL 90',
  'ARINC 424',
  'AIXM',
  'Winds Aloft',
  'TFR',
  'GeoJSON',
  'Weight & Balance',
];

export const PRINCIPLES = [
  {
    id: 'cockpit',
    title: 'Designed for the cockpit',
    body:
      'High-contrast layouts, big touch targets and night modes that protect dark adaptation — because nobody reads fine print in turbulence.',
  },
  {
    id: 'offline',
    title: 'Offline-first by default',
    body:
      'No signal at 41,000 feet? Everything critical keeps working, then syncs quietly once you’re back on the ground.',
  },
  {
    id: 'data',
    title: 'Data you can trust',
    body:
      'Every weather report, NOTAM and position is parsed, validated and timestamped — with sensible fallbacks when a source goes quiet.',
  },
  {
    id: 'ship',
    title: 'Ship fast, safely',
    body:
      'Automated tests, staged rollouts and crash monitoring get new features to pilots quickly — without surprises.',
  },
];

export const MANIFESTO = {
  text:
    'Our software gets read at night, in turbulence, at 140 knots, by people with better things to do. So we sweat every pixel, every millisecond and every edge case.',
  signature: 'Average Quality',
  aside: 'The name is the only average thing about us.',
};

export const ALTITUDES = [
  {
    level: 'Wrist',
    caption: 'Wearable apps',
    tech: ['Garmin Connect IQ', 'Monkey C', 'watchOS', 'Wear OS'],
  },
  {
    level: 'Cockpit',
    caption: 'Mobile & EFB',
    tech: ['Swift', 'SwiftUI', 'Kotlin', 'Jetpack Compose', 'React Native'],
  },
  {
    level: 'Ramp',
    caption: 'Web & operations',
    tech: ['React', 'TypeScript', 'Next.js', 'Node.js', 'WebSockets'],
  },
  {
    level: 'Cloud',
    caption: 'Data & infrastructure',
    tech: ['Python', 'Go', 'PostgreSQL', 'PostGIS', 'AWS', 'Google Cloud', 'Docker', 'Terraform'],
  },
];

export const PROCESS = [
  {
    fix: 'HELLO',
    title: 'Discovery',
    body:
      'A 30-minute call to understand your mission, your users and your constraints. No slide decks, no pressure.',
  },
  {
    fix: 'PLANS',
    title: 'Flight plan',
    body:
      'A clear scope, architecture and milestone plan with honest estimates — and the risks called out up front.',
  },
  {
    fix: 'BUILD',
    title: 'Build & test',
    body:
      'Short iterations with demos you can actually tap, tested on real devices in real-world conditions.',
  },
  {
    fix: 'CLIMB',
    title: 'Launch & support',
    body:
      'Store releases, monitoring and continuous improvement. You own the code and everything we build.',
  },
];

export const ASSURANCE = [
  {
    image: 0,
    title: 'Tested like it matters',
    body:
      'Code review, automated tests and a release checklist on every change. We pre-flight our software the way you pre-flight an aircraft.',
  },
  {
    image: 1,
    title: 'Secure by design',
    body:
      'Encryption in transit and at rest, least-privilege access and privacy-respecting analytics — built in from the first commit.',
  },
  {
    image: 2,
    title: 'You stay in command',
    body:
      'Your source code, infrastructure and documentation belong to you from day one. No lock-in, no black boxes.',
  },
];

export const CONTACT = {
  email: 'info@averagequality.com',
  phone: { display: '+1 771.222.1110', href: 'tel:+17712221110' },
  location: 'Austin, Texas',
  interests: ['Pilot / EFB app', 'Wearable app', 'Ops & dispatch', 'Data & APIs', 'Web platform', 'Something else'],
  timelines: ['As soon as possible', '1–3 months', '3–6 months', 'Just exploring'],
};
